module.exports = __webpack_public_path__ + "static/media/vitamina-c-si-coronavirusul.50a095c2.jpeg";